import {
  AutoComplete,
  ISelectType,
  useFetch,
  useFormContext,
} from "@4uhub/lib4uhub";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useWatch } from "react-hook-form";
import { list4uBusAutomationExecutions } from "../../../../../../../services/uBusAutomationRobot";
import { TFileIntegrationForm } from "../../fileIntegrationSchema";

const translationPath = "page.4uBus.uBusAutomationRobot.";

export const AutomationExecutionSelect = memo(() => {
  const { t } = useTranslation();

  const [options, setOptions] = useState<ISelectType[]>([]);

  const { sendRequest } = useFetch(list4uBusAutomationExecutions);

  const { control } = useFormContext<TFileIntegrationForm>();

  const software = useWatch({
    name: "software",
    control,
  });

  const automation = useWatch({
    name: "uBusAutomation",
    control,
  });

  const fetchOptions = useCallback(async () => {
    const { data, success } = await sendRequest({
      SoftwareCodes: software ? [software.code] : undefined,
      uBusAutomationCodes: automation ? [automation.code] : undefined,
    });
    if (data && success) {
      setOptions(data);
    }
  }, [sendRequest, software, automation]);

  useEffect(() => {
    fetchOptions();
  }, [fetchOptions]);

  return (
    <AutoComplete
      name="uBusAutomationExecution"
      label={t(translationPath + "ubus_automation_execution")}
      getOptionLabel={(option) => option.name}
      size="small"
      fullWidth
      clearIcon={false}
      options={options}
      disable={!software}
    />
  );
});
